import { configureStore } from "@reduxjs/toolkit";
import datasetsSlice from "./reducers/deviceLinkingAppStoreSlice";

export const store = configureStore({
    reducer: { datasets: datasetsSlice.reducer },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
